import React from 'react';
import ReactDOM from "react-dom";
import { useNavigate } from 'react-router-dom'
import { Button, Dropdown, Container, Form } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';

import { openLeftPanel, selectDataset, updateMyDatasets, updTableModal } from "./../../services/StoreContainer/actionCreators";
import * as actionTypes from "./../../services/StoreContainer/actionTypes";

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import cellEditFactory from 'react-bootstrap-table2-editor';

import { checkActiveProcess } from '../../utils/ProcessFunctions.js';
import { prettyDateTime, calculateElapsedTime } from "../../utils/DateFunctions.js"
import BaseActionForm from '../BaseActionForm';
import ImportDataset from '../ImportDataset';
import Decomposer from '../../actions/Decomposer';
import Connector from '../../actions/Connector';
import GeometryTransformer from '../../actions/GeometryTransformer';
import MassUpdate from '../../actions/MassUpdate';
import Normaliser from '../../actions/Normaliser';
import GeometryEditor from '../../actions/GeometryEditor';
import Publisher from '../Publisher';
import Tarifs from '../Tarifs';
import DatasetUtils from "../../services/DatasetUtils";
import Spinner from 'react-bootstrap/Spinner';
import Toast from 'react-bootstrap/Toast';
import Timer from '../../components/Timer/Timer';
import ColumnResizer from "column-resizer";

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import "./styles.scss"
import FilterIcon from '../../assets/filterIcon.svg';
import PencilIcon from '../../assets/pencil.svg';
import BackArrow from './../../assets/BackArrow.svg'
import DownloadGreen from './../../assets/downloadGreen.svg'
import DownloadBlue from './../../assets/downloadBlue.svg'
import FilterIconBlue from './../../assets/filterIconBlue.svg'
import HistoryIcon from './../../assets/historyIcon.svg'
import SortUp from './../../assets/sortUp.svg'
import SortDown from './../../assets/sortDown.svg'
import CloseCross from "../../assets/closeCross.svg";
import infoIcon from "../../assets/infoIcon.svg";
import UpdateTableModal from '../../components/UpdateTableModal/index.jsx';

export default function DatasetTable(props) {
    const navigation = useNavigate();
    const datasetsContainer = useSelector((store) => { return store.datasetsReducer });
    const interfaceContainer = useSelector((store) => { return store.interfaceReducer });
    const updTableModalContainer = useSelector((store) => { return store.reducerUpdTableModal });
    const dispatch = useDispatch();

    const navigateBack = () => {
        navigation('..', {
            relative: 'route',
            replace: true
        });
    }

    return <>
        <DatasetTableClass
            {...props}
            navigation={navigation}
            navigateBack={navigateBack}
            dispatch={dispatch}
            datasetsContainer={datasetsContainer}
            interfaceContainer={interfaceContainer}
            updTableModalContainer={updTableModalContainer}
        />
    </>
}

const inputTypes = [
    window.HTMLInputElement,
    window.HTMLSelectElement,
    window.HTMLTextAreaElement,
];

export const triggerInputChange = (node, value = '') => {
    // only process the change on elements we know have a value setter in their constructor
    if (inputTypes.indexOf(node.__proto__.constructor) > -1) {
        const setValue = Object.getOwnPropertyDescriptor(node.__proto__, 'value').set;
        const event = new Event('input', { bubbles: true });

        setValue.call(node, value);
        node.dispatchEvent(event);
    }
};


class DatasetTableClass extends BaseActionForm {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            dataset: null,
            token: null,
            filters: null,
            skip: 0,
            limit: 100,
            sortBy: null,
            sortOrder: null,
            data: null,
            columns: null,
            fixedFilters: null,
            filterName: 'Фильтры',
            cellHeight: 220,
            geometryEditor: null,
            fillingColumn: 'Автозаполнение',
            exportErrorMessage: null,
            dataIntervalWhenLeftPanelIsOpen: null,
        }
        this.tableSelector = "#listOfMarkersTable";
        this.someForDownload = null;
        this.refreshDataset = null;
    }

    async componentDidMount() {
        super.componentDidMount();

        let dataset = this.props.datasetsContainer.selectedDataset;

        if (!dataset) {
            //TODO: и все же остается редкая возможность, что в lastDatasets ничего нет,
            //или там датасеты другого автора (перелогинивались)
            //или вообще кинули ссылку на /lk/DatasetTable постороннему человеку
            const datasetsFromLS = localStorage.getItem('lastDatasets');
            if (datasetsFromLS) {
                const lastDatasets = JSON.parse(datasetsFromLS);
                if (lastDatasets && (lastDatasets.length > 0)) {
                    let datasetKey = lastDatasets[0].dataset;
                    if (this.props.datasetsContainer.datasets) {
                        dataset = this.props.datasetsContainer.datasets.find(d => (d.dataset === datasetKey));
                    } else {
                        const res = await this.lkApi.getDatasets({ filter: { 'dataset': datasetKey } });
                        dataset = res.datasets[0]
                    }
                }
            }
            if (dataset) {
                this.props.dispatch(selectDataset(dataset));
            }
        }

        this.setState({
            dataset: dataset,
            fixedFilters: this.props.datasetsContainer.fixedFilters
        }, () => {
            this.getNewToken();
            this.enableResize();
        })

        window.addEventListener('wheel', this.handleScroll);
        window.addEventListener('scroll', this.handleScroll);

        window.addEventListener("resize", this.stateOfGoTOButtons);
        this.stateOfGoTOButtons();
    }

    componentWillUnmount() {
        window.removeEventListener('wheel', this.handleScroll);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener("resize", this.stateOfGoTOButtons);

        if (this.state.dataset) {
            localStorage.removeItem(`tableScrollLeft_DatasetTable_${this.state.dataset.dataset}`);
            localStorage.removeItem(`tableScrollTop_DatasetTable_${this.state.dataset.dataset}`);
        }


        this.disableResize();

        this.dataInterval && clearInterval(this.dataInterval);

        if (this.state.dataIntervalWhenLeftPanelIsOpen) {
            clearInterval(this.state.dataIntervalWhenLeftPanelIsOpen);
            this.setState({ dataIntervalWhenLeftPanelIsOpen: null });
        }
    }

    componentWillMount() {
        if (this.state.dataset) {
            localStorage.removeItem(`tableScrollLeft_DatasetTable_${this.state.dataset.dataset}`);
            localStorage.removeItem(`tableScrollTop_DatasetTable_${this.state.dataset.dataset}`);
        }
    }

    stateOfGoTOButtons = () => {
        let headerWithTitleContainer = document.getElementById('headerWithTitleContainer')
        let headerWithTitle = document.getElementById('headerWithTitle')
        let goToContainer = document.getElementById('goToContainer')
        let needMenu = false
        if (headerWithTitleContainer && headerWithTitle && goToContainer) {
            needMenu = (headerWithTitleContainer.offsetWidth - headerWithTitle.offsetWidth - 45) < goToContainer.offsetWidth
        }

        // console.log(needMenu, headerWithTitleContainer.offsetWidth, headerWithTitle.offsetWidth, goToContainer.offsetWidth)
        if (needMenu) {
            this.setState({
                needMenu: needMenu
            }, () => {
                this.forceUpdate();
            });
        } else {
            this.forceUpdate();
        }
    }

    handleScroll = () => {
        let tableScroll = document.getElementById('tableScroll');
        if (tableScroll) {
            tableScroll.addEventListener('scroll', (e) => {
                localStorage.setItem(`tableScrollLeft_DatasetTable_${this.state.dataset.dataset}`, e.target.scrollLeft)
                localStorage.setItem(`tableScrollTop_DatasetTable_${this.state.dataset.dataset}`, e.target.scrollTop)
            })
        }
    }

    componentDidUpdate() {
        this.enableResize();
        this.updateScroll()
    }

    updateScroll = () => {
        if (this.state.dataset) {
            let tableContent = document.getElementById('tableScroll')
            let leftScroll = localStorage.getItem(`tableScrollLeft_DatasetTable_${this.state.dataset.dataset}`)
            let topScroll = localStorage.getItem(`tableScrollTop_DatasetTable_${this.state.dataset.dataset}`)
            if (tableContent) {
                tableContent.scrollLeft = leftScroll
                tableContent.scrollTop = topScroll
            }
        }
    }

    componentWillUpdate() {
        let dataset = this.props.datasetsContainer.selectedDataset;
        if (!dataset) {
            const datasetsFromLS = localStorage.getItem('lastDatasets');
            if (datasetsFromLS) {
                const lastDatasets = JSON.parse(datasetsFromLS);
                if (lastDatasets && (lastDatasets.length > 0)) {
                    let datasetKey = lastDatasets[0].dataset;
                    if (
                        this.props.datasetsContainer.datasets
                        && this.props.datasetsContainer.selectedDataset
                        && this.props.datasetsContainer.selectedDataset.dataset !== datasetKey
                    ) {
                        dataset = this.props.datasetsContainer.datasets.find(d => (d.dataset === datasetKey));
                        if (dataset) {
                            this.setState({
                                dataset: dataset,
                            }, () => this.getNewToken())
                        }
                        else this.props.navigateBack();
                    }
                }
            }
        }
        else if (
            this.state.dataset
            && this.props.datasetsContainer.datasets
            && this.props.datasetsContainer.selectedDataset
            && this.props.datasetsContainer.selectedDataset.dataset !== this.state.dataset.dataset
        ) {
            this.setState({
                dataset: this.props.datasetsContainer.selectedDataset,
            }, () => this.getNewToken())
        }


        let tableContent = document.getElementById('tableScroll')
        if (tableContent) {
            localStorage.setItem(`tableScrollLeft_DatasetTable_${this.state.dataset.dataset}`, tableContent.scrollLeft);
            localStorage.setItem(`tableScrollTop_DatasetTable_${this.state.dataset.dataset}`, tableContent.scrollTop);
        }
        this.disableResize();
    }

    enableResize() {
        if (ReactDOM.findDOMNode(this).querySelector(`${this.tableSelector}`) !== null) {
            let options = { resizeMode: 'overflow' };
            this.resizer = new ColumnResizer(
                ReactDOM.findDOMNode(this).querySelector(`${this.tableSelector}`),
                options
            );
        }
    }

    disableResize() {
        if (this.resizer) {
            this.resizer.reset({ disable: true });
        }
    }

    getNewToken = () => {
        if (this.state.dataset) {
            this.lkApi.getToken(this.state.dataset.dataset).then((response) => {
                this.setState({
                    token: response.token
                }, () => {
                    this.reloadData();
                    this.initPagination()
                });
            }
            );
        }
    }

    getCellStyleWidth = (column) => {
        let style = { minWidth: '125px' }

        if (column.text === "count" || column.text === "location") style = { minWidth: '70px' }
        if (column.text.length > 25 || column.text.indexOf(' ') > 10) style = { minWidth: "255px" }
        if (column.text.length > 30 || column.text.indexOf(' ') > 13) style = { minWidth: "330px" }

        return style;
    }

    refreshValuesOfHints = (input, hints, values, filter) => {

        let list = document.getElementById('FilterHints')
        if (list) list.style.display = 'unset'
        while (hints.firstChild) {
            hints.removeChild(hints.lastChild);
        }

        values.forEach((value, i) => {
            if (filter && value.toLowerCase().indexOf(filter.toLowerCase()) === -1) {
                return
            }
            let newChild = document.createElement('p')
            newChild.className = 'pInputCell'
            newChild.key = 'pInputCell' + i
            newChild.innerText = value
            let addhint = (e) => {
                triggerInputChange(input, value)
                this.closeInputHints()
                newChild.removeEventListener('mousedown', addhint)
            }
            newChild.addEventListener('mousedown', addhint)
            hints.appendChild(newChild)

        })

        if (!hints.firstChild) {
            this.closeInputHints()
        }
    }

    headerFormatter(column, colIndex, { sortElement, filterElement }) {
        let sort = (field, order) => {
            if (this.state.sortOrder === order && this.state.sortOrder !== null && this.state.sortBy === column.dataField) {
                order = null
                field = null
            }
            this.setState({
                sortBy: field,
                sortOrder: order
            },
                () => {
                    this.reloadData();
                });
        }

        let binding = this
        return <div className={colIndex === 0 ? 'tableContent' : 'tableContent titleBorderLeft'} style={this.getCellStyleWidth(column)}>
            <p style={{ marginBottom: '0px', marginRight: '5px', display: 'inline-block', maxHeight: '40px', overflowY: 'auto' }}>{column.text}</p>
            {column.feature && <div className='tableFeature'><p className='tableFeatureP'>{column.feature}</p></div>}
            <div className='columnButtonsCont'>
                <img
                    id={'sortUp_' + column.dataField}
                    className={(this.state.sortOrder === 'asc' && this.state.sortBy === column.dataField) ? 'sortActive' : 'sortIcon'}
                    src={SortUp}
                    alt='SortUpIcon'
                    onClick={() => { sort(column.dataField, 'asc') }}
                />
                <img id={'sortDown_' + column.dataField} className={(this.state.sortOrder === 'desc' && this.state.sortBy === column.dataField) ? 'sortActive' : 'sortIcon'} src={SortDown} alt='SortDownIcon' onClick={() => { sort(column.dataField, 'desc') }} />

                {column.dataField !== '_id' && column.dataField !== 'x' && column.dataField !== 'y' && column.filter !== null &&
                    <img src={FilterIcon}
                        data-tip data-for={'filter' + column.dataField}
                        alt={'filter'}
                        className={'filterIcon'}
                        onClick={function (event) {
                            event.stopPropagation();
                            event.preventDefault();
                            const textFilterElem = document.getElementById("textFilterColumn-" + column.dataField);
                            if (textFilterElem && textFilterElem.style.display === 'none') {
                                textFilterElem.style.setProperty('display', 'inline-block');
                                textFilterElem.style.setProperty('position', 'relative');
                                textFilterElem.style.setProperty('top', '5px');
                                document.getElementById('datasetTable').style.setProperty('--header-height', '75px');
                                document.getElementById('tableScroll').scrollIntoView({
                                    block: "end",
                                    inline: "nearest"
                                })
                            }
                            else {
                                textFilterElem.style.setProperty('display', 'none')
                                if (document.querySelectorAll(`div.textFilterClass[style="display: inline-block; position: relative; top: 5px;"]`).length === 0)
                                    document.getElementById('datasetTable').style.setProperty('--header-height', '60px');
                            }

                            let input = document.getElementById('text-filter-column-' + column.dataField)
                            input && (input.autocomplete = 'off')
                            input.placeholder = `Введите ${column.text}`
                            let values = []
                            if (binding.state.dataset && binding.state.dataset.state && binding.state.dataset.state.fieldsQuality && binding.state.dataset.state.fieldsQuality[column.dataField]) {
                                values = binding.state.dataset.state.fieldsQuality[column.dataField].frequentValues
                            }
                            if (input && values) {
                                input.addEventListener('focusout', () => {
                                    binding.closeInputHints()
                                })
                                input.addEventListener('click', () => {

                                    let hints = document.getElementById('FilterHints')

                                    // let hintsSize = hints.getBoundingClientRect();
                                    let inputSize = input.getBoundingClientRect();

                                    if (hints && hints.style.display !== 'unset') {

                                        binding.refreshValuesOfHints(input, hints, values)

                                        hints.style.top = inputSize.top + inputSize.height + 'px'
                                        hints.style.left = inputSize.left + 'px'
                                        hints.style.display = 'unset'
                                    }
                                })
                            }
                            binding.disableResize()
                            binding.enableResize()
                        }}
                    />
                }
                {column.dataField !== '_id' &&
                    <img src={PencilIcon}
                        data-tip data-for={'massUpdate' + column.dataField}
                        alt={'massUpdate'}
                        className={'massUpdateIcon'}
                        onClick={(event) => {
                            event.stopPropagation();
                            this.setState({
                                fillingColumn: column.dataField
                            }, () => {
                                this.props.dispatch(openLeftPanel(actionTypes.MASS_UPDATE));
                            });
                        }}
                    />
                }
            </div>


            {/* <ReactTooltip key={"tooltip " + 'filter' + column.dataField} id={'filter' + column.dataField} className='showIconTooltipClass' place='top' clickable={false} delayHide={100} effect='solid'>
                Фильтрация
            </ReactTooltip> */}

            <div className='textFilterClass' id={"textFilterColumn-" + column.dataField} style={{ display: 'none' }}>
                {filterElement}
                <div className="inputInfo" onClick={(e) => {
                    // console.log(e,'text-filter-column-'+column.dataField, document.getElementById('infoList'))
                    let list = document.getElementById('infoList')
                    if (list && list.style.display !== 'unset') {
                        list.style.top = e.clientY - 15 + 'px'
                        list.style.left = e.clientX - 15 + 'px'
                        list.style.display = 'unset'
                        list.alt = 'text-filter-column-' + column.dataField
                    }
                }} >
                    <img src={infoIcon} className="infoIcon" alt='infoIcon' />
                </div>
            </div>
        </div >
    }

    reloadData = async () => {
        console.log("reloadData");

        this.nameFilters = {}
        if (this.state.dataset && this.state.token) {

            let promises = [
                this.generalApi.getObjects(
                    "userDatasetByToken",
                    this.state.token,
                    {
                        filter: this.state.filters,
                        projection: null,
                        limit: this.state.limit,
                        skip: this.state.skip,
                        sortBy: this.state.sortBy,
                        sortOrder: this.state.sortOrder
                    }),

                this.generalApi.getObjectsCount(
                    "userDatasetByToken",
                    this.state.token,
                    {
                        filter: this.state.filters
                    })
            ];
            let responses = await Promise.all(promises);

            if (responses && (responses.length === 2)) {
                let dataResponce = responses[0];

                let columns = [];
                this.state.dataset.fields.forEach((field) => {
                    let capt = field.caption
                    columns.push({
                        dataField: field.name,
                        text: capt,
                        sort: false,
                        width: '100',
                        feature: field.feature ? field.feature : '',
                        editable: (field.type === 'oarObject' || field.type === 'object' || typeof cell === 'object') ? false : true,
                        specialEditor: (field.type === "geometry" ? "geometryEditor" : undefined),
                        headerClasses: 'headerClasses' + (capt === 'Номер дома' ? ' mini' : ((capt === 'Улица' || capt === 'Муниципалитет' || capt === 'Регион' || capt === 'Геометрия в WGS-84') ? ' medium' : '')),
                        headerFormatter: this.headerFormatter.bind(this),
                        filter: !(field.type === "geometry" || field.type === 'oarObject' || field.type === 'object' || typeof cell === 'object') ? textFilter({
                            getFilter: (filter) => {
                                // nameFilter was assigned once the component has been mounted.                               
                                (this.nameFilters[field.name] = filter)
                            },
                            onInput: (e) => {
                                let values = []
                                if (this.state.dataset && this.state.dataset.state && this.state.dataset.state.fieldsQuality && this.state.dataset.state.fieldsQuality[field.name]) {
                                    values = this.state.dataset.state.fieldsQuality[field.name].frequentValues
                                }
                                let filterDiv = document.getElementById('FilterHints')
                                filterDiv && this.refreshValuesOfHints(e.target, filterDiv, values, e.target.value)
                            },
                        }) : null,
                        formatter: (cell, row, rowIndex, formatExtraData) => {
                            if (field.type === "geometry") {
                                let info = DatasetUtils.getGeometryInfo(cell);
                                return <div className="markersTableCell">{info}</div>;
                            } else
                                if (field.type === 'oarObject' || field.type === 'object' || typeof cell === 'object') {
                                    return <div className="markersTableCell">
                                        {(cell) && (typeof cell === 'object') ? 'Есть' : '-'}
                                    </div>;
                                }
                                else {
                                    return <div className="markersTableCell">{cell}</div>;
                                }
                        },
                        csvFormatter: (field.type === "geometry" || field.type === 'oarObject' || field.type === 'object' || typeof cell === 'object') ?
                            (cell, row, rowIndex, formatExtraData) => {
                                return JSON.stringify(cell, null, '\t');
                            } : null
                    });
                });
                if (columns.length === 0) {
                    columns.push({
                        headerClasses: 'headerClasses',
                        headerFormatter: this.headerFormatter,
                        dataField: "_id",
                        text: "_id"
                    });
                }

                for (let i = 0; i < dataResponce.length; i++) {
                    dataResponce[i]._id = dataResponce[i]._id;
                }

                columns.push({
                    dataField: '',
                    text: '',
                    sort: false,
                    editable: false,
                    headerClasses: 'headerClasses',
                    headerFormatter: (column, colIndex, { sortElement, filterElement }) => {
                        return <div className='headerClassesZero'></div>
                    }
                })
                this.setState({
                    data: dataResponce,
                    columns: columns,
                    count: responses[1].count,
                }, () => this.props.dispatch(updTableModal(false, null)));
            }
        }
    }

    beforeSaveCell = (object, field) => {
        let fieldParts = field.split('.');
        this.needPushObjectFields = [];

        if (fieldParts.length > 0) {
            if (!object[fieldParts[0]]) {
                object[fieldParts[0]] = "";
            }
        }
        if (fieldParts.length > 1) {
            if (!object[fieldParts[0]]) {
                object[fieldParts[0]] = { [fieldParts[1]]: "" };
                this.needPushObjectFields.push(fieldParts[0]);
            }
            if (!object[fieldParts[0]][fieldParts[1]]) {
                object[fieldParts[0]][fieldParts[1]] = "";
            }
        }
        if (fieldParts.length > 2) {
            if (!object[fieldParts[0]][fieldParts[1]]) {
                object[fieldParts[0]][fieldParts[1]] = { [fieldParts[2]]: "" };
                this.needPushObjectFields.push(fieldParts[0] + '.' + fieldParts[1]);
            }
            if (!object[fieldParts[0]][fieldParts[1]][fieldParts[2]]) {
                object[fieldParts[0]][fieldParts[1]][fieldParts[2]] = "";
            }
        }
        if (fieldParts.length > 3) {
            if (!object[fieldParts[0]][fieldParts[1]][fieldParts[2]]) {
                object[fieldParts[0]][fieldParts[1]][fieldParts[2]] = { [fieldParts[3]]: "" };
                this.needPushObjectFields.push(fieldParts[0] + '.' + fieldParts[1] + '.' + fieldParts[2]);
            }
            if (!object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]]) {
                object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]] = "";
            }
        }
        if (fieldParts.length > 4) {
            if (!object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]]) {
                object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]] = { [fieldParts[4]]: "" };
                this.needPushObjectFields.push(fieldParts[0] + '.' + fieldParts[1] + '.' + fieldParts[2] + '.' + fieldParts[3]);
            }
            if (!object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]][fieldParts[4]]) {
                object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]][fieldParts[4]] = "";
            }
        }
        if (fieldParts.length > 5) {
            if (!object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]][fieldParts[4]]) {
                object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]][fieldParts[4]] = { [fieldParts[5]]: "" };
                this.needPushObjectFields.push(fieldParts[0] + '.' + fieldParts[1] + '.' + fieldParts[2] + '.' + fieldParts[3] + '.' + fieldParts[4]);
            }
            if (!object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]][fieldParts[4]][fieldParts[5]]) {
                object[fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]][fieldParts[4]][fieldParts[5]] = "";
            }
        }

        let data = this.state.data;
        for (let i = 0; i < data.length; i++) {
            if (data[i]._id === object._id) {
                data[i] = object;
            }
        }
        this.setState({
            data: data
        });

    }

    afterSaveCell = (newValue, object, field) => {
        if (object && field && this.state.dataset) {
            let updatingObjects = [];

            if (this.needPushObjectFields && this.needPushObjectFields.length > 0) {
                this.needPushObjectFields.forEach((field) => {
                    updatingObjects.push({
                        _id: object._id,
                        [field]: { "_": "_" }
                    });
                })
            }

            updatingObjects.push({
                _id: object._id,
                [field]: newValue
            });

            let runInSequence = async () => {
                let response = null;
                for (let i = 0; i < updatingObjects.length; i++) {
                    response = await this.lkApi.updateObject(
                        updatingObjects[i],
                        "userDatasetByToken",
                        this.state.token,
                        updatingObjects[i]._id,
                        { partial: true }
                    )
                }
                return response;
            };

            runInSequence().then((response) => {
                if (response.modifiedCount) {
                    let data = JSON.parse(JSON.stringify(this.state.data));
                    for (let i = 0; i < data.length; i++) {
                        if (data[i]._id === object._id) {
                            let fieldParts = field.split('.');
                            if (fieldParts.length === 1) {
                                data[i][fieldParts[0]] = newValue;
                            }
                            if (fieldParts.length === 2) {
                                data[i][fieldParts[0]][fieldParts[1]] = newValue;
                            }
                            if (fieldParts.length === 3) {
                                data[i][fieldParts[0]][fieldParts[1]][fieldParts[2]] = newValue;
                            }
                            if (fieldParts.length === 4) {
                                data[i][fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]] = newValue;
                            }
                            if (fieldParts.length === 5) {
                                data[i][fieldParts[0]][fieldParts[1]][fieldParts[2]][fieldParts[3]][fieldParts[4]] = newValue;
                            }
                        }
                    }
                    this.setState({
                        data: data
                    });
                }
                else {
                    this.addAlert(response);
                }
            });

            this.needPushObjectFields = null;
        }
    }

    saveGeometryFromEditor = (newGeometry) => {
        let object = this.state.geometryEditor.object;
        let field = this.state.geometryEditor.field;

        console.log("saveGeometryFromEditor", object, field, newGeometry);

        this.beforeSaveCell(object, field);
        this.afterSaveCell(newGeometry, object, field);

        this.setState({
            geometryEditor: null
        });
        this.props.dispatch(openLeftPanel(null));
    }

    initPagination = () => {
        let statusOfPages = [];
        let numberCurrent = 1;
        for (let i = 0; i < 5; i++) {
            statusOfPages[i] = {
                cur: false,
                num: i + 1,
                name: i + 1,
                font: '1rem',
            }
        }
        statusOfPages[0].cur = true;
        this.setState({ statusOfPages, numberCurrent, skip: 0 })
    }

    getNewDataFromPagination = (ev) => {
        console.log(ev.target.value)
        let key = ev.which || ev.keyCode || 0;

        if (key === 13) {
            this.setState({ limit: parseInt(ev.target.value), skip: 0 }, () => {
                this.reloadData();
                this.initPagination()
            });
        }

        ev.target.removeEventListener("keypress", this.getNewDataFromPagination);
    }

    getNumberPagination = (e) => {
        if (e.target.value && e.target.value !== '' && e.target.value !== '0') {
            e.target.value = e.target.value.replace(/[^0-9]/g, '')
            e.target.addEventListener("keypress", this.getNewDataFromPagination);
        }
    }

    onPageClick(num, name) {

        let numberCurrent = name;
        let statusOfPages = this.state.statusOfPages;
        let pages = Math.ceil(parseInt(this.state.count) / parseInt(this.state.limit))

        if (pages - name > 1) {
            if (num > 3 && num < (pages - 1)) num = 3;
            if (name > 2 && num < 3) num = 3;
        }

        switch (num) {
            case 1:
                statusOfPages[0].name = name;
                statusOfPages[1].name = name + 1
                statusOfPages[2].name = name + 2
                statusOfPages[3].name = name + 3
                statusOfPages[4].name = name + 4
                break;
            case 2:
                statusOfPages[0].name = name - 1
                statusOfPages[1].name = name
                statusOfPages[2].name = name + 1
                statusOfPages[3].name = name + 2
                statusOfPages[4].name = name + 3
                break;
            case 3:
                statusOfPages[0].name = name - 2
                statusOfPages[1].name = name - 1
                statusOfPages[2].name = name
                statusOfPages[3].name = name + 1
                statusOfPages[4].name = name + 2
                break;
            case 4:
                statusOfPages[0].name = name - 3
                statusOfPages[1].name = name - 2
                statusOfPages[2].name = name - 1
                statusOfPages[3].name = name
                statusOfPages[4].name = name + 1
                break;
            case 5:
                statusOfPages[0].name = name - 4
                statusOfPages[1].name = name - 3
                statusOfPages[2].name = name - 2
                statusOfPages[3].name = name - 1
                statusOfPages[4].name = name
                break;
            default:
                console.log("Нет значений в onPageClick");
        }

        for (let i = 0; i < 5; i++) {
            statusOfPages[i].font = (statusOfPages[i].name).toString().length < 4 ? '1rem' : '10px'
            if (i + 1 === num) { statusOfPages[i].cur = true; }
            else statusOfPages[i].cur = false
        }


        this.setState({ numberCurrent, skip: (name - 1) * this.state.limit, statusOfPages }, () => this.reloadData())

    }

    onArrowClick(toWhere) {

        let pages = (Math.ceil(parseInt(this.state.count) / parseInt(this.state.limit)))
        let statusOfPages = this.state.statusOfPages;
        let currPage = this.state.numberCurrent;
        let currPageNum;

        for (let i = 0; i < 5; i++) {
            if (statusOfPages[i].cur === true) currPageNum = i + 1
        }


        switch (toWhere) {
            case 'end':
                this.onPageClick(5, pages)
                break;
            case 0:
                this.onPageClick(1, 1)
                break;
            case 1:
                if (currPage < pages) {
                    currPageNum = currPageNum < 5 ? currPageNum + 1 : 1;
                    this.onPageClick(currPageNum, currPage + 1)
                }
                break;
            case -1:
                if (currPage > 1) {
                    currPageNum = currPageNum > 1 ? currPageNum - 1 : 5
                    this.onPageClick(currPageNum, currPage - 1)
                }
                break;
            default:
                console.log("Нет значений в onArrowClick");
        }
    }

    paginationPages = () => {

        let pages = Math.ceil(parseInt(this.state.count) / parseInt(this.state.limit));
        let toLast = false;
        let toNext = false;
        let toFirst = false;
        let toPrev = false;
        let numberCurrent = this.state.numberCurrent;
        let statusOfPages = this.state.statusOfPages;
        // console.log(pages, statusOfPages, numberCurrent);
        if ((pages > 0) && (pages < 6)) {
            toNext = !statusOfPages[pages - 1].cur ? true : false;
            toPrev = !statusOfPages[0].cur ? true : false;
        }
        else {
            toFirst = (numberCurrent > 3) ? true : false;
            toPrev = (numberCurrent > 1) ? true : false;
            toLast = (!statusOfPages[3].cur && !statusOfPages[4].cur) ? true : false;
            toNext = !statusOfPages[4].cur ? true : false;
        }

        return <div className='paginationContainer'>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <p className={'pPagination'}>В выборке {this.state.count} записей. </p>
                <p className={'pPagination'}>Отображать: </p>
                <input className={'inputPagination'} defaultValue={this.state.limit} type={'text'} onChange={this.getNumberPagination} />
            </div>


            <div style={{ display: 'flex', alignItems: 'center' }}>
                <ul className={"tablePagination" + (pages < 2 ? ' none' : '')}>
                    <li className={"page-item" + (toFirst ? '' : ' noneOpacity')} title="В начало"><div onClick={() => { this.onArrowClick(0) }} className="page-link">&lt;&lt;</div></li>
                    <li className={"page-item" + (toPrev ? '' : ' noneOpacity')} title="Предыдущая"><div onClick={() => { this.onArrowClick(-1) }} className="page-link">&lt;</div></li>
                    <li id={'page1'} className={"page-item" + (statusOfPages[0].cur ? ' active' : '')} ><div style={{ fontSize: statusOfPages[0].font }} onClick={() => { this.onPageClick(1, statusOfPages[0].name) }} className="page-link str">{statusOfPages[0].name}</div></li>
                    <li id={'page2'} className={"page-item" + (statusOfPages[1].cur ? ' active' : '')} ><div style={{ fontSize: statusOfPages[1].font }} onClick={() => { this.onPageClick(2, statusOfPages[1].name) }} className="page-link str">{statusOfPages[1].name}</div></li>
                    <li id={'page3'} className={"page-item" + (statusOfPages[2].cur ? ' active' : '') + (pages < 3 ? ' none' : '')} ><div style={{ fontSize: statusOfPages[2].font }} onClick={() => { this.onPageClick(3, statusOfPages[2].name) }} className="page-link str">{statusOfPages[2].name}</div></li>
                    <li id={'page4'} className={"page-item" + (statusOfPages[3].cur ? ' active' : '') + (pages < 4 ? ' none' : '')} ><div style={{ fontSize: statusOfPages[3].font }} onClick={() => { this.onPageClick(4, statusOfPages[3].name) }} className="page-link str">{statusOfPages[3].name}</div></li>
                    <li id={'page5'} className={"page-item" + (statusOfPages[4].cur ? ' active' : '') + (pages < 5 ? ' none' : '')} ><div style={{ fontSize: statusOfPages[4].font }} onClick={() => { this.onPageClick(5, statusOfPages[4].name) }} className="page-link str">{statusOfPages[4].name}</div></li>
                    <li className={"page-item" + (toNext ? '' : ' noneOpacity')} title="Следующая"><div onClick={() => { this.onArrowClick(1) }} className="page-link">&gt;</div></li>
                    <li className={"page-item" + (toLast ? '' : ' noneOpacity')} title="В конец"><div onClick={() => { this.onArrowClick('end') }} className="page-link">&gt;&gt;</div></li>
                </ul>
                <p className={'pPagination'}>Перейти на страницу: </p>
                <input className={'inputPagination'} placeholder={'номер'} type={'number'} onChange={(e) => {
                    setTimeout(() => {
                        if (pages < e.target.value) e.target.value = ''
                        else if (e.target.value && e.target.value > 0) this.onPageClick(e.target.value % 5, parseInt(e.target.value))
                    }, 2000)
                }} />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>

            </div>
        </div>
    }

    setNativeValue(element, value) {
        let lastValue = element.value;
        element.value = value;
        let event = new Event("input", { target: element, bubbles: true });
        // React 15
        event.simulated = true;
        // React 16
        let tracker = element._valueTracker;
        if (tracker) {
            tracker.setValue(lastValue);
        }
        element.dispatchEvent(event);
    }

    combiFilter = (filterFromButton) => {
        //let filterState = {};

        let elems = document.querySelectorAll('.textFilterClass');
        elems.forEach((element) => {
            element.style.setProperty('display', 'none')
        });

        let inputs = document.getElementsByClassName('filter text-filter form-control undefined');
        for (let [, value] of Object.entries(inputs)) {
            if (value.value) {
                this.setNativeValue(value, '')
            };
        };

        if (filterFromButton) {
            for (let [key, value] of Object.entries(filterFromButton.filter)) {
                if (document.getElementById('text-filter-column-' + key)) {
                    let text;
                    if (value && value['$regex']) text = value['$regex']
                    else text = 'null';
                    this.setNativeValue(document.getElementById('text-filter-column-' + key), text !== 'null' ? text : 'пусто')
                    document.getElementById('textFilterColumn-' + key).style.setProperty('display', 'inline-block')
                    window.getComputedStyle().setProperty('--header-height', '120px')
                    //filterState[key] = text !== 'null' ? { '$regex': text, '$options': 'i' } : null
                };
            };

            if (filterFromButton.sortBy && filterFromButton.sortOrder) {
                this.setState({ sortBy: filterFromButton.sortBy, sortOrder: filterFromButton.sortOrder, filterName: filterFromButton.caption, filters: filterFromButton.filter }, () => { this.reloadData() });
            }
            else {
                this.setState({ filterName: filterFromButton.caption, filters: filterFromButton.filter }, () => { this.reloadData() });
            }

        }
        else this.setState({ filterName: 'Стандартные фильтры' }, () => { this.reloadData() });
    }

    resizeOfCell = () => {
        let modalField = document.getElementById('datasetTable');
        let cellHeight = this.state.cellHeight;

        if (cellHeight === 30) {
            modalField.style.setProperty('--heightCell', '180px');
            cellHeight = 220
        }
        else {
            modalField.style.setProperty('--heightCell', '30px');
            cellHeight = 30
        }
        this.setState({ cellHeight: cellHeight })
    }

    getNavLine = () => {
        if (this.state.dataset) {
            let dataset = this.props.datasetsContainer.selectedDataset || this.state.dataset;
            let buttonsList = this.getPropertiesForButtonsList(dataset);
            let operations = this.getOperationsList();

            let avaliableOperations = [];

            operations.forEach(operation => {
                if (operation.type !== actionTypes.DATASET_TABLE) {
                    if (((operation.field === 'any') && (!buttonsList.nothing)) || ((operation.field !== 'any') && (buttonsList[operation.field]))) {
                        avaliableOperations.push({
                            icon: this.sectionIcon(operation.type),
                            click: () => {
                                if (operation.anotherPage) {
                                    this.goToSection(this.props.navigation, operation.anotherPage);
                                } else {
                                    this.props.dispatch(openLeftPanel(operation.type));
                                }
                            },
                            name: this.sectionName(operation.type),
                            notify: buttonsList[operation.field + 'Notify'] ? buttonsList[operation.field + 'Notify'] : undefined
                        });
                    }
                }
            })

            if (buttonsList.nothing) {
                return null;
            }

            if (avaliableOperations)
                if (this.state.needMenu) {
                    return <Dropdown className="goToContainerDrop" id='goToContainer'>
                        <Dropdown.Toggle className="datasetButton" variant="success">
                            Действия
                        </Dropdown.Toggle>
                        <Dropdown.Menu className='dropMenuDownload'>
                            {avaliableOperations.map((operation, i) => {
                                return <div className={'featuresFreeMini'} key={'featuresFree' + i} onClick={() => operation.click()}>
                                    <img className='dataset-info-icon' src={operation.icon} alt='ChainIcon' />
                                    <p className="textNavi">{operation.name}</p>
                                    {operation.notify &&
                                        <img className='dataset-info-notify' src={operation.notify} alt='notify' />
                                    }
                                </div>
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                }
                else {
                    return <div className='goToContainer' id='goToContainer'>
                        {avaliableOperations.map((operation, i) => {
                            return <div className={'featuresFree'} key={'featuresFree' + i} onClick={() => operation.click()}>
                                <img className='dataset-info-icon' src={operation.icon} alt='ChainIcon' />
                                <p className="textNavi">{operation.name}</p>
                                {operation.notify &&
                                    <img className='dataset-info-notify' src={operation.notify} alt='notify' />
                                }
                            </div>
                        })}
                    </div>
                }
        }
    }

    exportToFile = (format) => {

        this.setState({ hideExportButtons: true });
        setTimeout(() => {
            this.setState({ hideExportButtons: false });
        }, 5000)

        if (this.state.dataset) {
            this.lkApi.lKExporterTask(
                this.state.filters,
                this.state.dataset._id,
                format,
                {
                    sortBy: this.state.sortBy,
                    sortOrder: this.state.sortOrder
                }).then((response) => {
                    if (response.taskId) {
                        this.props.dispatch(updateMyDatasets());
                        this.setState({ exportErrorMessage: null });
                    }
                    else {
                        this.setState({ exportErrorMessage: response.errorMessageRu });
                    }
                });
        }
    }

    getListForDownload = (someForDownload) => {
        return someForDownload.toReversed().map((file, index) => (
            <a key={index} href={"/exportedDatasets" + file.file} className="dropdown-item blueLink">
                {(file.file.indexOf(".geojson") >= 0 ? "GeoJSON" : "XLSX") + " от " + prettyDateTime(new Date(parseInt(file.time)))}
            </a>
        ))
    }

    getButtonsLine = () => {
        let dataset = this.props.datasetsContainer.selectedDataset || this.state.dataset;
        let exportRunning = checkActiveProcess(dataset, 'lk_exporter');

        let allFiles = dataset.export || [];
        let filesExceptLast = allFiles.slice(0, allFiles.length - 1);
        let lastFile = allFiles.length > 0 ? allFiles[allFiles.length - 1] : null;

        return this.state.data && this.state.columns &&
            <div className='postHeaderLineContainer'>
                <div className='postHeaderLine'>
                    {!exportRunning && !this.state.hideExportButtons &&
                        <Button
                            id='export2'
                            className='datasetButton greenBtn'
                            key={'datasetButton'}
                            onClick={() => {
                                this.exportToFile("XLSX");
                            }}>
                            <img src={DownloadGreen} className='imageForButton' alt='DownloadGreen' />
                            Excel
                        </Button>
                    }
                    {!exportRunning && (DatasetUtils.unsetGeometryFeatures(this.state.dataset.fields).length === 0) && !this.state.hideExportButtons &&
                        <Button
                            id='export1'
                            className='datasetButton'
                            key={'datasetButton2'}
                            onClick={() => {
                                this.exportToFile("GEOJSON");
                            }}>
                            <img src={DownloadBlue} className='imageForButton' alt='DownloadBlue' />
                            GeoJSON
                        </Button>
                    }

                    {(exportRunning || this.state.hideExportButtons) &&
                        <Form style={{ marginRight: "20px" }}>
                            <Spinner
                                style={{ marginRight: "5px" }}
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            формируем файл {exportRunning ? Math.floor(parseFloat(exportRunning.lastInfo.progress) * 100) + '%' : '...'}
                        </Form>
                    }

                    {this.exportErrorMessage &&
                        <Toast
                            style={{ width: 'max-content', maxWidth: '700px', marginRight: '20px' }}
                            bg={'danger'}
                        >
                            <Toast.Header
                                style={{ padding: '0.3rem 0.4rem' }}
                                closeButton={false}
                            >
                                <strong>{`Произошла ошибка, экспорт не запущен: ${this.exportErrorMessage}`}</strong>
                            </Toast.Header>
                        </Toast>
                    }

                    {!exportRunning && lastFile &&
                        <>
                            {(calculateElapsedTime(new Date(parseInt(lastFile.time)))).elapsedHours < 3 ?
                                <>
                                    <a href={"/exportedDatasets" + lastFile.file} style={{ textDecoration: "none", marginRight: '5px' }}>
                                        <p className="textNavi">Файл {lastFile.file.indexOf(".geojson") >= 0 ? "GeoJSON" : "XLSX"} готов</p>
                                    </a>
                                    <div style={{ display: 'flex' }}>
                                        (
                                        <Timer startTimeInMilliseconds={(calculateElapsedTime(new Date(parseInt(lastFile.time)))).elapsedMilliseconds} />
                                        )
                                    </div>
                                </>
                                :
                                <a href={"/exportedDatasets" + lastFile.file} style={{ textDecoration: "none", color: 'rgba(94, 129, 244, 1)' }}>
                                    <p className="textNavi">
                                        <span>
                                            {lastFile.file.indexOf(".geojson") >= 0 ? "GeoJSON" : "XLSX"} от {prettyDateTime(new Date(parseInt(lastFile.time)), true)}
                                        </span>
                                    </p>
                                </a>
                            }
                        </>
                    }

                    {!exportRunning && (filesExceptLast.length > 0) &&
                        <Dropdown className="dropdownChooseDowloads" key='dropdownChooseDowloads'>
                            <Dropdown.Toggle className="dropDatasetButton" variant="success">
                                <img src={HistoryIcon} className='imageForButton' alt='HistoryIcon' />
                                {`ещё ${filesExceptLast.length}`}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className='dropMenuDownload'>
                                <div className='dropListClass' id="dropdownChooseDowloads" >
                                    {this.getListForDownload(filesExceptLast)}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                </div>
                <div className='postHeaderLine rightLine'>

                    {this.state.fixedFilters && <Dropdown className="dropdownChooseFilter" key='dropdownChooseFilter'>
                        {/* <Button variant="primary" className='datasetMargin datasetButton' onClick={this.combiFilter}>Тестовый комбинированный фильтр</Button> */}
                        <Dropdown.Toggle className="dropDatasetButton" variant="success">
                            <img src={FilterIconBlue} className='imageForButton' alt='FilterIconBlue' />{this.state.filterName}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <div className='dropListClass' id="dropdownChooseDowloads" >
                                {this.state.fixedFilters.map((filter) => {
                                    return <Dropdown.Item key={filter.caption} onClick={() => { this.combiFilter(filter) }}> {filter.caption} </Dropdown.Item>
                                })
                                }
                                <Dropdown.Item key={'clear'} onClick={() => { this.combiFilter() }}> Очистить </Dropdown.Item>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>}

                    <input className='switchClass' type="checkbox" id="switch" onChange={() => this.resizeOfCell()} /><label className={'switchClassLabel'} htmlFor="switch" id='switchLabel'>Toggle</label> <p className='heightChange'>Компактный режим</p>

                </div>
            </div>
    }

    closeInputHints = () => {
        let list = document.getElementById('FilterHints')
        if (list) list.style.display = 'none'
        while (list.lastElementChild) {
            list.removeChild(list.lastElementChild);
        }
    }

    getFilterHints = () => {
        return <div className='FilterHints' id='FilterHints'
            onMouseLeave={(e) => {
                this.closeInputHints()
            }}>
        </div>
    }

    getInfoList = () => {
        let listOfFilterInstruments = [
            {
                text: 'Пусто',
                value: 'пусто'
            },

            {
                text: 'Не пусто',
                value: 'не пусто'
            },

            {
                text: 'Строго равно',
                value: '='
            },

            {
                text: 'Больше',
                value: '>'
            },

            {
                text: 'Меньше',
                value: '<'
            },

            {
                text: 'Очистить',
                value: ''
            }
        ]

        return <div className='infoList' id='infoList'
            onMouseLeave={(e) => {
                let list = document.getElementById('infoList')
                if (list) list.style.display = 'none'
            }}>
            {listOfFilterInstruments.map((line, i) => {
                return <p className='pInputCell' key={'pInputCell' + i} onClick={() => {
                    if (document.getElementById('infoList') && document.getElementById(document.getElementById('infoList').alt)) {
                        let inp = document.getElementById(document.getElementById('infoList').alt)
                        let valueOfInp = inp.value
                        let firstsymbol
                        let newValue = line.value
                        if ((valueOfInp.length > 0)) {
                            firstsymbol = valueOfInp[0]
                            if ((line.value === '>' || line.value === '<' || line.value === '=')) {
                                if ((firstsymbol === '>' || firstsymbol === '<' || firstsymbol === '=')) newValue = line.value + inp.value.slice(1)
                                else newValue = line.value + inp.value
                            }
                        }

                        triggerInputChange(inp, newValue)
                    }
                }}>{line.text}</p>
            })}
        </div>
    }

    render() {

        let exitCross = () => {
            return <img className='exitCross' src={CloseCross} onClick={() => {
                this.props.dispatch(openLeftPanel(null));
                this.reloadData();
            }} alt='CloseCross' />

        }

        let openedLeftPanel = (this.props.interfaceContainer.leftPanel);

        let leftPanel = this.props.interfaceContainer.leftPanel;

        return (<div className=" rightPanel">
            {(leftPanel === actionTypes.CONNECTOR) && <Connector filters={this.state.filters} count={this.state.count} />}
            {(leftPanel === actionTypes.DECOMPOSER) && <Decomposer />}
            {(leftPanel === actionTypes.GEOMETRY_TRANSFORMER) && <GeometryTransformer />}
            {(leftPanel === actionTypes.GEOMETRY_EDITOR) && <GeometryEditor object={this.state.geometryEditor.object} field={this.state.geometryEditor.field} onSave={this.saveGeometryFromEditor} />}
            {(leftPanel === actionTypes.NORMALISER) && <Normaliser />}
            {(leftPanel === actionTypes.PUBLISHER) && <Publisher />}
            {(leftPanel === actionTypes.MY_TARIF) && <Tarifs />}
            {(leftPanel === actionTypes.IMPORT_DATASET) && <ImportDataset exitCross={exitCross} />}
            {(leftPanel === actionTypes.MASS_UPDATE) && <MassUpdate field={this.state.fillingColumn} filters={this.state.filters} count={this.state.count} token={this.state.token} />}
            {leftPanel && exitCross()}
            {this.props.updTableModalContainer.isOpen && <UpdateTableModal tableName={this.props.updTableModalContainer.tableName} />}

            <div id={"datasetTable"} className={"rightPanel flexColumn " + (openedLeftPanel ? ' noClick' : '')}>
                {this.renderAlerts()}
                <div className='headerWithTitleContainer' id='headerWithTitleContainer'>
                    <div className='headerWithTitle' id='headerWithTitle'>
                        <div className="headerContainer">
                            <img src={BackArrow} className='backArrow' alt='back arrow' onClick={() => this.props.navigateBack()} />
                            <div className='titleContainer'><p className="headerMargin">Табличный просмотр</p></div>
                        </div>
                        {this.state.data &&
                            <div className="bottomHeaderContainer">
                                <p style={{ paddingLeft: '45px' }}>{this.state.dataset.name}</p>
                            </div>
                        }
                    </div>
                    {this.state.dataset && this.getNavLine()}
                </div>


                {this.state.dataset && !this.state.data && !this.state.columns &&
                    this.renderPreloader()
                }

                {this.state.dataset && this.getButtonsLine()}

                {this.state.data && this.state.columns &&

                    <div className="postHeaderContainer textRoboto infoContainer">

                        {/* //TODO: а вроде прикольная строчка с прогрессом, восстановим?
                        this.state.dataset &&
                                    <div style={{ marginLeft: "15px" }}>

                                        {this.state.dataset.runningTasks?.map((task, i) => (
                                            <div key={"infoProcesses" + this.state.dataset._id + task.performer} style={{ display: 'flex' }}>
                                                <div className="loader" />
                                                <p
                                                    className='infoProcesses'>
                                                    {
                                                        "Запущен " + DatasetUtils.getNameProgress(task.performer) +
                                                        ', прогресс: ' + (task.lastInfo && (task.lastInfo.progress !== undefined) ? (Math.floor(parseFloat(task.lastInfo.progress) * 100) + '%') : 'неизвестен')
                                                    }
                                                </p>
                                            </div>
                                        ))}

                                    </div>
                                                */  }

                        <Container className="containerStyle" id="tableScroll">
                            {this.getInfoList()}
                            {this.getFilterHints()}
                            <BootstrapTable
                                bootstrap4
                                keyField="_id"
                                id="listOfMarkersTable"
                                striped
                                hover
                                condensed
                                tabIndexCell
                                classes="datasetTable"
                                headerClasses='headerLineStyle'
                                remote={{ filter: true }}
                                data={this.state.data}
                                columns={this.state.columns}
                                filter={filterFactory()}
                                cellEdit={cellEditFactory({
                                    mode: 'dbclick',
                                    onStartEdit: (row, column, rowIndex, columnIndex) => {
                                        console.log('onStartEdit', row, column, rowIndex, columnIndex);
                                        let input = document.getElementsByClassName('react-bootstrap-table-editing-cell')[0];
                                        if (input) {
                                            const p = document.createElement("p");
                                            let nullHandler = () => {
                                                this.beforeSaveCell(row, column.dataField);
                                                this.afterSaveCell(null, row, column.dataField)
                                                p.removeEventListener('mousedown', nullHandler)
                                            }
                                            p.className = 'toNullButton'
                                            p.innerHTML = "null"
                                            p.addEventListener('mousedown', nullHandler)
                                            input.appendChild(p)
                                        }
                                        if (column.specialEditor === "geometryEditor") {

                                            let wgsGeometry = row;
                                            let fieldParts = column.dataField.split('.');
                                            fieldParts.forEach((part) => {
                                                if (wgsGeometry) {
                                                    wgsGeometry = wgsGeometry[part];
                                                }
                                            });

                                            input.children.item(0).value = JSON.stringify(wgsGeometry.coordinates);
                                            this.setState({
                                                geometryEditor: {
                                                    object: row,
                                                    field: column.dataField
                                                }
                                            }, () => {
                                                this.props.dispatch(openLeftPanel(actionTypes.GEOMETRY_EDITOR));
                                            });
                                        }

                                        return false;
                                    },
                                    beforeSaveCell: (oldValue, newValue, row, column) => {
                                        this.beforeSaveCell(row, column.dataField);
                                    },
                                    afterSaveCell: (oldValue, newValue, row, column) => {
                                        this.afterSaveCell(newValue, row, column.dataField);
                                    },
                                })}
                                onTableChange={(f, p) => {
                                    let filters = null;

                                    /*     
                                    строгое равенство по значению
                                    {field: "1234"}
                                    или
                                    {field: 1234, field2: 1234}
                                         
                                    вхождение подстроки
                                    {
                                        field: { 
                                            '$regex': 'комп', 
                                            '$options': 'i' 
                                        }
                                    }     
     
                                    пустое поле
                                    {field: null}
          
                                    не пустое поле
                                    {field: {$ne: null}}
          
                                    поле больше или равно значения
                                    {field: {$gte: 123}}
                                         
                                    меньше или равно
                                    {field: {$lte: 123}}     
                                    */

                                    for (let fieldName in p.filters) {
                                        if (!filters) {
                                            filters = {};
                                        }

                                        switch (p.filters[fieldName].filterVal) {
                                            case "пусто":
                                                filters[fieldName] = null;
                                                break;

                                            case "не пусто":
                                                filters[fieldName] = { '$ne': null };
                                                break;

                                            default:
                                                let type = null;
                                                this.state.dataset.fields.forEach((field) => {
                                                    if (field.name === fieldName) {
                                                        type = field.type;
                                                    }
                                                });

                                                if (type === "string") {
                                                    // if (p.filters[fieldName].filterVal[0] === '=') filters[fieldName] = p.filters[fieldName].filterVal.slice(1);
                                                    switch (p.filters[fieldName].filterVal[0]) {
                                                        case '=':
                                                            if (p.filters[fieldName].filterVal.slice(1).length < 1) filters[fieldName] = { '$regex': '', '$options': 'i' };
                                                            else filters[fieldName] = p.filters[fieldName].filterVal.slice(1);
                                                            break;
                                                        case '>':
                                                            console.log(p.filters[fieldName].filterVal, p.filters[fieldName].filterVal.slice(1).length)
                                                            if (p.filters[fieldName].filterVal.slice(1).length < 1) filters[fieldName] = { '$regex': '', '$options': 'i' };
                                                            else filters[fieldName] = { '$gte': p.filters[fieldName].filterVal.slice(1) }
                                                            break;
                                                        case '<':
                                                            if (p.filters[fieldName].filterVal.slice(1).length < 1) filters[fieldName] = { '$regex': '', '$options': 'i' };
                                                            else filters[fieldName] = { '$lte': p.filters[fieldName].filterVal.slice(1) }
                                                            break;

                                                        default:
                                                            filters[fieldName] = { '$regex': p.filters[fieldName].filterVal, '$options': 'i' };
                                                            break;
                                                    }
                                                }
                                                else if (type === "geometry") {
                                                    try {
                                                        let geom = JSON.parse(p.filters[fieldName].filterVal);
                                                        filters[fieldName] = { '$geoWithin': { '$geometry': geom } };
                                                    } catch (e) {
                                                        console.log(e);
                                                    }
                                                }
                                                else {
                                                    switch (p.filters[fieldName].filterVal[0]) {
                                                        case '=':
                                                            if (p.filters[fieldName].filterVal.slice(1).length < 1) filters[fieldName] = { '$regex': '', '$options': 'i' };
                                                            else filters[fieldName] = p.filters[fieldName].filterVal.slice(1);
                                                            break;
                                                        case '>':
                                                            if (p.filters[fieldName].filterVal.slice(1).length < 1) filters[fieldName] = { '$regex': '', '$options': 'i' };
                                                            else filters[fieldName] = { '$gte': parseFloat(p.filters[fieldName].filterVal.slice(1)) }
                                                            break;
                                                        case '<':
                                                            if (p.filters[fieldName].filterVal.slice(1).length < 1) filters[fieldName] = { '$regex': '', '$options': 'i' };
                                                            else filters[fieldName] = { '$lte': parseFloat(p.filters[fieldName].filterVal.slice(1)) }
                                                            break;

                                                        default:
                                                            filters[fieldName] = parseFloat(p.filters[fieldName].filterVal)
                                                            break;
                                                    }
                                                }
                                                break;
                                        }
                                    }
                                    this.setState({
                                        filters: filters
                                    },
                                        () => {
                                            this.reloadData();
                                        });
                                }
                                }
                            /></Container>
                        {this.state.statusOfPages && this.paginationPages()}
                    </div>
                }
            </div>
        </div>
        );
    }
}

